import ENDPOINTS from './endpoints';
import axios from 'axios';

axios.interceptors.response.use(undefined, function axiosRetryInterceptor(err) {
  var config = err.config;
  if(!config || !config.retry) return Promise.reject(err);
  
  config.__retryCount = config.__retryCount || 0;
  
  if(config.__retryCount >= config.retry) {
      // Reject with the error
      return Promise.reject(err);
  }

  config.__retryCount += 1;
  
  var backoff = new Promise(function(resolve) {
      setTimeout(function() {
          resolve();
      }, config.retryDelay || 1);
  });

  return backoff.then(function() {
      return axios(config);
  });
});

export const formBody = (details) => {
  var formBody = [];
  for (var property in details) {
    var encodedKey = encodeURIComponent(property);
    var encodedValue = encodeURIComponent(details[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }
  formBody = formBody.join("&");
  return formBody;
}

// fetch map details
export function fetchMapDetails(id, callback) {
  const CancelToken = axios.CancelToken;
  let cancel;

  return axios({
    method: 'GET',
    url: ENDPOINTS.LICENSE,
    params: {
      id: id
    },  
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
      if (typeof callback === 'function') {
        callback(cancel);
      }
    }),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    }
  });
}

// confirm
export function confirm(id, confirm, callback) {
  const CancelToken = axios.CancelToken;
  let cancel;

  return axios({
    method: 'GET',
    url: ENDPOINTS.CONFIRM,
    params: {
      id,
      confirm,
    },  
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
      if (typeof callback === 'function') {
        callback(cancel);
      }
    }),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    }
  });
}

// verify qr image
export function verifyQR(encodedJPG, callback) {
  const CancelToken = axios.CancelToken;
  let cancel;

  const details = {
    qr: encodedJPG
  };

  return axios({
    method: 'POST',
    url: ENDPOINTS.LICENSE,
    data: details,
    retry: 5,
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
      if (typeof callback === 'function') {
        callback(cancel);
      }
    }),
    headers: {
      'Content-Type': 'application/json',
    }
  });
}

// get sale information
export function getSaleDetails(callback) {
  const CancelToken = axios.CancelToken;
  let cancel;
  return axios({
    method: 'GET',
    url: ENDPOINTS.AVAILABLE,
    retry: 5,
    cancelToken: new CancelToken(function executor(c) {
      cancel = c;
      if (typeof callback === 'function') {
        callback(cancel);
      }
    }),
    headers: {
      'Content-Type': 'application/json',
    }
  });
}

// UPDATE DETAILS
export function updateQR(data = {}, update, callback) {
  const CancelToken = axios.CancelToken;
  let cancel;
  const METHOD = update ? 'PUT' : 'POST';
  let filterData = {};
  const isSale = Boolean(data.sale);
  const relatedSaleKeys = ['s_url', 's_price', 's_cur']

  Object.keys(data).forEach(key => {
    switch (key) {
      case 'sale': {
        filterData[key] = isSale ? '1' : '0';
        break;
      }
      default: {
        if (!isSale && relatedSaleKeys.indexOf(key) >= 0) break;
        filterData[key] = data[key];
        break;
      }
    }
  });
  const json = JSON.stringify(filterData);
  return axios({
    method: 'PUT',
    data: json,
    retry: 10,
    url: ENDPOINTS.LICENSE,
    cancelToken: new CancelToken(function executor(c) {
      if (typeof callback === 'function') {
        callback(cancel);
      }
    }),
    headers: {
      'Content-Type': 'application/json',
    }
  });
}

export default {
  verifyQR,
  fetchMapDetails,
  updateQR,
  confirm,
  getSaleDetails,
}



// WEBPACK FOOTER //
// ./src/api/requests.js